import { Result } from "antd";
const LoadError = ({ message }) => {
  return <Result status="error" title={message} />;
};

export default LoadError;
